import React, { ChangeEvent } from "react";
import moment from "moment-timezone";
import styles from "./index.module.scss";

interface FilterDropdownProps {
  options: string[];
  currentSelection: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}

export const FilterDropdown = ({ options = [], currentSelection, onChange }: FilterDropdownProps) => {
  const formatDate = (day: string): string => moment(new Date(day)).format("MM/DD/YYYY");

  return (
    <select
      className={styles.select}
      value={currentSelection}
      onChange={onChange}
    >
      <option value="All">All</option>
      {options.map((day, index) => (
        <option key={index} value={formatDate(day)}>
          {formatDate(day)}
        </option>
      ))}
    </select>
  );
};
